import isArray from 'is-any-array';

/**
 * Computes the mean of the given values
 * @param {Array<number>} input
 * @return {number}
 */

function sum(input) {
  if (!isArray(input)) {
    throw new TypeError('input must be an array');
  }

  if (input.length === 0) {
    throw new TypeError('input must not be empty');
  }

  var sumValue = 0;

  for (var i = 0; i < input.length; i++) {
    sumValue += input[i];
  }

  return sumValue;
}

export default sum;
